<template>
  <div>
    <!--ROW1-->
    <v-layout row align-center justify-center wrap>
      <v-flex sm12 md12 lg12  >
        <v-card dark color="white">        
          <v-img class="header_parents"
              src="cover_home_descargables.png" 
            >
            
             
            <v-layout align-end justify-center fill-height>
              <logoutbutton></logoutbutton>
              <p style="font-size:1.5vw;text-align:center;font-family:Poppins" class="hidden-sm-and-down">
                {{row1_text1}}</p>            
              <p style="font-size:3.5vw;text-align:center;font-family:Poppins" class="hidden-md-and-up">
                {{row1_text1}}</p>                
            </v-layout>
        </v-img>
        </v-card>
      </v-flex>      
    </v-layout>
    <v-layout class="mt-5" row align-center justify-center fill-height>
      <v-flex xs12 sm12 md8 lg8>
        <v-layout class="mt-5" row align-center justify-center>
        <v-flex xs8 sm10 md8 lg8>
        <v-card class="" style="background-color:#EE1133;font-size:3vw">
          <v-layout align-center justify-center >
            <v-flex xs6 sm6 md6 lg6>
              <v-text class="white--text">Videos</v-text>
            </v-flex>
            <v-flex xs2 sm2 md2 lg2>
              <v-img src="video.png" />
            </v-flex>
          </v-layout>
        </v-card>
        </v-flex>
        </v-layout>
        <v-layout align-center justify-center fill-height row>
          <v-carousel class="remove-shadow" :cycle="false" hide-delimiters light=true height="500">
          <v-carousel-item v-for="item in videos" v-bind:key="item.url">
            <v-layout fill-height row align-center justify-space-around>                           
              <v-flex xs8 sm10 md8 lg6>
                <v-card style="background-color:#EE1133;color:#DDDDDD">
                  <iframe height="300px" width="100%" v-bind:src="item.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  <h3 class="mx-2">{{item.title}}</h3>
                  <p class="mx-2">{{item.sub_title}}</p>
                </v-card>
              </v-flex>                 
            </v-layout>
            </v-carousel-item>          
          </v-carousel>
        </v-layout>
      </v-flex>
    </v-layout>         
    
      <v-tabs   class="pestanas" fixed-tabs=true centered hide-slider="" height="80">

        <v-flex xs12 sm12 md12 lg12 style="background-color:purple;display:inline-flex;justify-content:center; space-evenly">
          <v-tab>
            <p class="tab-text">{{row3_text1}}</p>
            <img class="hidden-sm-and-down" style="width:30%" src="juegos_icono.png" />
          </v-tab>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 style="background-color:cornflowerblue;display:inline-flex;justify-content: space-evenly">
            <v-tab>
              <p class="tab-text">{{row3_text2}}</p>
              <img class="hidden-sm-and-down" style="width:30%" src="cuentos.png"/>
            </v-tab>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 style="background-color:mediumvioletred;display:inline-flex;justify-content: space-evenly">
          <v-layout align-center justify-space-around row>
              <v-tab>
              <p class="tab-text">{{row3_text3}}</p>
              <img class="hidden-sm-and-down" style="width:30%" src="coloreables.png"/>
              </v-tab>
            </v-layout>
        </v-flex>
        <v-tab-item>
          <v-card style="background-color:purple;" flat>
            <v-layout align-center justify-center>
            <v-flex xs12 sm12 md10 lg8>
            <v-carousel :cycle="false" class="remove-shadow">
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in juegos[0]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>
                        <!--<p>{{item.text}}</p>-->      
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in juegos[1]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
              </v-carousel-item>
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in juegos[2]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in juegos[3]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>               
              </v-carousel-item>
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in juegos[4]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in juegos[5]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>              
              </v-carousel-item>            
            </v-carousel>
            </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card style="background-color:cornflowerblue;" flat>
            <v-layout align-center justify-center>
            <v-flex xs12 sm12 md10 lg8>
            <v-carousel class="remove-shadow" :cycle="false">
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in cuentos[0]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in cuentos[1]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>                
              </v-carousel-item>
              <!--<v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in cuentos[2]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in cuentos[3]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px;" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>                
              </v-carousel-item>
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in cuentos[4]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in cuentos[5]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>           
              </v-carousel-item>-->      
            </v-carousel>
            </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card style="background-color:mediumvioletred;" flat>
            <v-layout align-center justify-center>
            <v-flex xs12 sm12 md10 lg8>
            <v-carousel class="remove-shadow" :cycle="false">
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in coloreables[0]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in coloreables[1]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <!--<p>{{item.text}}</p>-->
                        <p>{{row4_text1}}</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>                
              </v-carousel-item>
              <!--<v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in coloreables[2]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in coloreables[3]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>                
              </v-carousel-item>
              <v-carousel-item>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in coloreables[4]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>
                <v-layout align-start justify-center row>            
                  <div class="mx-2 my-3" style="display:flex;justify:space-evenly;" v-for="item in coloreables[5]" v-bind:key="item.url">                    
                      <v-card flat style="background-color:white;text-align:center">
                      <a v-bind:href="item.url" download target="_blank">
                        <img style="width:25vw;max-width:150px" v-bind:src="item.thumb"/>                        
                        <p>{{item.text}}</p>
                        <p>Descargar</p>
                      </a>
                      </v-card>
                  </div>                                               
                </v-layout>                
              </v-carousel-item>-->            
            </v-carousel>
            </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
        
      </v-tabs>      



  <!--</v-container>-->
  </div>
</template>

<script>
import logoutbutton from "../components/logout-button"

  export default {
    components:{
      logoutbutton
    },
    data(){    
    let language=localStorage.getItem('language');
    if (language=='es') {
      return{
        row1_text1:'Disfruta de la variedad de contenidos exclusivos diseñados por expertos en educación infantil',
        row3_text1:'Juegos',
        row3_text2:"Cuentos",
        row3_text3:'Dibujos',
        row4_text1:'Descargar'
        
        ,videos:[
          {url:"https://www.youtube.com/embed/8oMfG8FucJI",title:"Educacion",sub_title:"Nutrición a la hora del desayuno"},
          {url:"https://www.youtube.com/embed/wlLF9Et8BMA",title:"Educacion",sub_title:"Nutrición a la hora de comer"}, 
          {url:"https://www.youtube.com/embed/y9p1e3wSjyU",title:"Educacion",sub_title:"Como afecta el estres en niños y adultos"},
          {url:"https://www.youtube.com/embed/voBYXeh8VI0",title:"Educacion",sub_title:"Como vivir mas relajados"},
          {url:"https://www.youtube.com/embed/xaCr822qXiI",title:"Educacion",sub_title:"Transmitir felicidad a mi familia"},
          {url:"https://www.youtube.com/embed/R1aGdKM9WeY",title:"Educacion",sub_title:"Comunicación de doble vinculo"}, 
          {url:"https://www.youtube.com/embed/EYW3E7p0z5Q",title:"Educacion",sub_title:"Comunicación de doble vinculo 2"}, 
          {url:"https://www.youtube.com/embed/4ysQR7jUCQg",title:"Educacion",sub_title:"Comunicación de doble vinculo 3"},   
          {url:"https://www.youtube.com/embed/tJbHBoOnusk",title:"Educacion",sub_title:"Que hacer en caso de quemaduras"},
          {url:"https://www.youtube.com/embed/9PtoI-c8KUs",title:"Educacion",sub_title:"Que hacer en caso de un golpe en la cabeza"}
        ]
        ,cuentos:[

          [
            {thumb:'cuento_lalo_lily.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Lalo_y_Lily_Lalabumers.pdf',text:'Lalo y Lily'},
            {thumb:'Portada_Una_solucion_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Una_Solucio%cc%81n_Lalabum.pdf',text:'Solucion Lalabum'},
            {thumb:'Portada_Bum_bum_precaucion_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Bum_bum_precaucio%cc%81n_Lalabum.pdf',text:'Precaucion Lalabum'},            
          ],
          [
            {thumb:'Portada_Energia_Lalabumer_en_tu_dia.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Energi%cc%81a_Lalabumer_en_tu_di%cc%81a.pdf',text:'Energia Lalabumer'},
            {thumb:'Portada_Soy_un_Campeon_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_soy_un_campeo%cc%81n_Lalabum.pdf',text:'Campeon Lalabum'},
            {thumb:'PROXIMAMENTE.png',url:'https://www.lalabumapp.com/descargas_padres/PROXIMAMENTE.png',text:'Proximamente'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ]                 
        ],
        juegos:[
          [
            {thumb:'download_buena_conducta_.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/Mi%20carta%20de%20buena%20conducta.pdf',text:'Buena conducta'},
            {thumb:'download_memorama_dh.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/memorama-derechosninos.pdf',text:'Derechos humanos'},
            {thumb:'download_loteria.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/Loter%c3%ada%20Lalabum.pdf',text:'Loteria lalabum'},            
          ],
          [
            {thumb:'download_memorama.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/MEMORAMA.pdf',text:'Memorama Lalabum'},
            {thumb:'download_respeto_mi_cuerpo.jpg',url:'https://www.lalabumapp.com/descargas_padres/juegos/Respeto_mi_cuerpo.pdf',text:'Respeto mi cuerpo'},
            {thumb:'Portada_responsable_de_mi_cuerpo.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/soy_responsable_de_mi_cuerpo.pdf',text:'Mi cuerpo'},            
          ],
          [
            {thumb:'Portada_ordeno_mi_cuarto.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/ordeno_mi_cuarto.pdf',text:'Memorama emociones'},
            {thumb:'Portda_une_las_mitades.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/soy_responsable_de_mi_alimentacion.pdf',text:'Ordeno mi cuarto'},
            {thumb:'Portada_une_con_profesiones.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/todos_somos_iguales.pdf',text:'Mi alimentacion'},            
          ],
          [
            {thumb:'Portada_mis_pertenencias.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/mis_pertenencias.pdf',text:'Somos iguales'},
            {thumb:'Portada_identifica_arboles.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/regando_arboles.pdf',text:'Mis pertenencias'},
            {thumb:'Portada_Calendario_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/Calendario%20de%20las%20buenas%20actitudes.pdf',text:'Regando arboles'},            
          ],
          [
            {thumb:'Portada_Convivencia_familiar.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/convivo_con_mi_familia.pdf',text:'Buenas actitudes'},
            {thumb:'Portada_cinco_sentidos.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/mis_5_sentidos.pdf',text:'Convivencia'},
            {thumb:'Portada_plastilina_casera.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/plastilina_casera.pdf',text:'Los sentidos'},            
          ],
          [
            {thumb:'PROXIMAMENTE.png',url:'https://www.lalabumapp.com/descargas_padres/PROXIMAMENTE.png',text:'Proximamente'},
            {thumb:'PROXIMAMENTE.png',url:'https://www.lalabumapp.com/descargas_padres/PROXIMAMENTE.png',text:'Proximamente'},
            {thumb:'PROXIMAMENTE.png',url:'https://www.lalabumapp.com/descargas_padres/PROXIMAMENTE.png',text:'Proximamente'},            
          ]                 
        ],coloreables:[
          [
            {thumb:'Portada_colorea_camino.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/camino_a_la_escuela.pdf',text:'Camino a la escuela'},
            {thumb:'Portada_colorea_agua.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/ciudo_el_agua.pdf',text:'Cuido el agua'},
            {thumb:'Portada_colorea_palabras.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/mis_horarios.pdf',text:'Mis Horarios'},            
          ],
          [
            {thumb:'Portada_colorea_revolucion.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/revolucion.pdf',text:'Revolucion'},
            {thumb:'PROXIMAMENTE.png',url:'https://www.lalabumapp.com/descargas_padres/PROXIMAMENTE.png',text:'Proximamente'},
            {thumb:'PROXIMAMENTE.png',url:'https://www.lalabumapp.com/descargas_padres/PROXIMAMENTE.png',text:'Proximamente'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ]                 
        ]
      }
      } else{
          return{
        row1_text1:'Enjoy the variety of exclusive content designed by experts in child education.',
        row3_text1:'Games',
        row3_text2:"Stories",
        row3_text3:'Drawings',
        row4_text1:'Download'
        
        ,videos:[
          {url:"https://www.youtube.com/embed/8oMfG8FucJI",title:"Education",sub_title:"Nutrition at breackfast time"},
          {url:"https://www.youtube.com/embed/wlLF9Et8BMA",title:"Education",sub_title:"Nutrition at lunchtime"}, 
          {url:"https://www.youtube.com/embed/y9p1e3wSjyU",title:"Education",sub_title:"How stress affects children and adults"},
          {url:"https://www.youtube.com/embed/voBYXeh8VI0",title:"Education",sub_title:"how to live more relaxed"},
          {url:"https://www.youtube.com/embed/xaCr822qXiI",title:"Education",sub_title:"Convey happiness to my family"},
          {url:"https://www.youtube.com/embed/R1aGdKM9WeY",title:"Education",sub_title:"Double link communication"}, 
          {url:"https://www.youtube.com/embed/EYW3E7p0z5Q",title:"Education",sub_title:"Double link communication 2"}, 
          {url:"https://www.youtube.com/embed/4ysQR7jUCQg",title:"Education",sub_title:"Double link communication 3"},   
          {url:"https://www.youtube.com/embed/tJbHBoOnusk",title:"Education",sub_title:"What to do in case of burns?"},
          {url:"https://www.youtube.com/embed/9PtoI-c8KUs",title:"Education",sub_title:"What to do in case of a blow to the head?"}
        ]
        ,cuentos:[
          [
            {thumb:'cuento_lalo_lily.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Lalo_y_Lily_Lalabumers.pdf',text:'Lalo y Lily'},
            {thumb:'Portada_Una_solucion_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Una_Solucio%cc%81n_Lalabum.pdf',text:'Solucion Lalabum'},
            {thumb:'Portada_Bum_bum_precaucion_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Bum_bum_precaucio%cc%81n_Lalabum.pdf',text:'Precaucion Lalabum'},            
          ],
          [
            {thumb:'Portada_Energia_Lalabumer_en_tu_dia.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_Energi%cc%81a_Lalabumer_en_tu_di%cc%81a.pdf',text:'Energia Lalabumer'},
            {thumb:'Portada_Soy_un_Campeon_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/cuentos/Cuento_soy_un_campeo%cc%81n_Lalabum.pdf',text:'Campeon Lalabum'},
            {thumb:'COMINGSOON.png',url:'https://www.lalabumapp.com/descargas_padres/COMINGSOON.png',text:'Comming Soon'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ]                 
        ],
        juegos:[
          [
            {thumb:'download_buena_conducta_.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/Mi%20carta%20de%20buena%20conducta.pdf',text:'Buena conducta'},
            {thumb:'download_memorama_dh.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/memorama-derechosninos.pdf',text:'Derechos humanos'},
            {thumb:'download_loteria.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/Loter%c3%ada%20Lalabum.pdf',text:'Loteria lalabum'},            
          ],
          [
            {thumb:'download_memorama.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/MEMORAMA.pdf',text:'Memorama Lalabum'},
            {thumb:'download_respeto_mi_cuerpo.jpg',url:'https://www.lalabumapp.com/descargas_padres/juegos/Respeto_mi_cuerpo.pdf',text:'Respeto mi cuerpo'},
            {thumb:'Portada_responsable_de_mi_cuerpo.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/soy_responsable_de_mi_cuerpo.pdf',text:'Mi cuerpo'},            
          ],
          [
            {thumb:'Portada_ordeno_mi_cuarto.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/ordeno_mi_cuarto.pdf',text:'Memorama emociones'},
            {thumb:'Portda_une_las_mitades.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/soy_responsable_de_mi_alimentacion.pdf',text:'Ordeno mi cuarto'},
            {thumb:'Portada_une_con_profesiones.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/todos_somos_iguales.pdf',text:'Mi alimentacion'},            
          ],
          [
            {thumb:'Portada_mis_pertenencias.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/mis_pertenencias.pdf',text:'Somos iguales'},
            {thumb:'Portada_identifica_árboles.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/regando_arboles.pdf',text:'Mis pertenencias'},
            {thumb:'Portada_Calendario_Lalabum.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/Calendario%20de%20las%20buenas%20actitudes.pdf',text:'Regando arboles'},            
          ],
          [
            {thumb:'Portada_Convivencia_familiar.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/convivo_con_mi_familia.pdf',text:'Buenas actitudes'},
            {thumb:'Portada_cinco_sentidos.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/mis_5_sentidos.pdf',text:'Convivencia'},
            {thumb:'Portada_plastilina_casera.png',url:'https://www.lalabumapp.com/descargas_padres/juegos/plastilina_casera.pdf',text:'Los sentidos'},            
          ],
          [
            {thumb:'COMINGSOON.png',url:'https://www.lalabumapp.com/descargas_padres/COMINGSOON.png',text:'Proximamente'},
            {thumb:'COMINGSOON.png',url:'https://www.lalabumapp.com/descargas_padres/COMINGSOON.png',text:'Proximamente'},
            {thumb:'COMINGSOON.png',url:'https://www.lalabumapp.com/descargas_padres/COMINGSOON.png',text:'Proximamente'},            
          ]                 
        ],coloreables:[
          [
            {thumb:'Portada_colorea_camino.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/camino_a_la_escuela.pdf',text:'Camino a la escuela'},
            {thumb:'Portada_colorea_agua.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/ciudo_el_agua.pdf',text:'Cuido el agua'},
            {thumb:'Portada_colorea_palabras.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/mis_horarios.pdf',text:'Mis Horarios'},            
          ],
          [
            {thumb:'Portada_colorea_revolución.png',url:'https://www.lalabumapp.com/descargas_padres/coloreables/revolucion.pdf',text:'Revolucion'},
            {thumb:'COMINGSOON.png',url:'https://www.lalabumapp.com/descargas_padres/COMINGSOON.png',text:'Proximamente'},
            {thumb:'COMINGSOON.png',url:'https://www.lalabumapp.com/descargas_padres/COMINGSOON.png',text:'Proximamente'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ],
          [
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},
            {thumb:'https://via.placeholder.com/300x300.png',url:'http://www.google.com'},            
          ]                 
        ]

          }

      }
    }
    
  }
</script>

<style>
.login_padres{
  margin-top: 250px;
}

.pestanas{
  
  justify-content: center;
}

.remove-shadow{
  box-shadow:none !important;
  web-kit-box-shadow:none !important;
}


.tab-text{
    font-size: 2vw;
    color: white;
    text-transform: none !important;
}
  
@media only screen and (max-width: 768px) {
  .tab-text{
    font-size: 4vw;
    color: white;
    text-transform: none !important;
  }
}


.vertical-center {
  padding-left:10%;
  margin: 0px;
  position:absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.text-top-row{
  font-size:2vw;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;  
}

.text-top-row-2{
  font-size:3vw;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  margin-top: 20%;
  margin-bottom: 20%;
  display: block;
}

.text-center{
  font-size:2.5vw;
  padding-top: 2vw;
  text-align: center;
}

.text-guia{
  font-size:2vw;  
}


.cenefa{    
  top: 90%;
}

.repeating-gradient {
    background-image: repeating-linear-gradient(-45deg,
                        rgba(255,0,0,.25),
                        rgba(255,0,0,.25) 5px,
                        rgba(0,0,255,.25) 5px,
                        rgba(0,0,255,.25) 10px
                      );
  }

  
</style>